import { BasicEvent } from "./BasicEvent";

export class TransportavstandBerakningCompletedEventMessage extends BasicEvent {
    arbetsorderId: number;
    destineringIdList: number[];

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "TransportavstandBerakningCompletedEventMessage";
    constructor($type: string) {
        super($type);
    }
}
